<h2 mat-dialog-title>Verify shared billing access</h2>
<form (submit)="verify(); $event.preventDefault()">
    <mat-dialog-content>
        <p id="management-otp-description">A one time password has been emailed to you. Enter it below to manage shared billing users.</p>
        <mat-form-field appearance="outline" class="w-full">
            <mat-label>One time password</mat-label>
            <input matInput [formField]="otpForm.otp" autocomplete="one-time-code" />
            @for (error of otpForm.otp().errors(); track error.kind) {
                <mat-error>{{ error.message }}</mat-error>
            }
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matButton type="button" mat-dialog-close>Cancel</button>
        <button matButton="filled" type="submit" [disabled]="!otpForm().valid()">Verify</button>
    </mat-dialog-actions>
</form>
